import { create } from "zustand";

export const useEntityStore = create((set, get) => ({
  entities: {
    building: null,
    topography: null,
    site: null
  },

  // --- SETTERS ---
  setBuildingEntity: (buildingEntity) =>
    set((state) => ({
      entities: { ...state.entities, building: buildingEntity },
    })),

  setTopographyEntity: (topographyEntity) =>
    set((state) => ({
      entities: { ...state.entities, topography: topographyEntity },
    })),

  setSiteEntity: (siteEntity) =>
    set((state) => ({
      entities: { ...state.entities, site: siteEntity },
    })),

  // --- CLEAR FUNCTIONS ---
  clearBuilding: () =>
    set((state) => ({
      entities: { ...state.entities, building: null },
    })),

  clearTopography: () =>
    set((state) => ({
      entities: { ...state.entities, topography: null },
    })),

    clearSite: () =>
    set((state) => ({
      entities: { ...state.entities, site: null },
    })),


    serialize: () => {
    const entities = get().entities;
    // Add identifiers so we know what's what after serialization
    const json = JSON.stringify({
      type: "EntityStore",
      data: {
        building: entities.building,
        topography: entities.topography,
        site: entities.site,
      },
    });
    return json;
  },
}));